import { render, staticRenderFns } from "./TraysMobile.vue?vue&type=template&id=e66cb778&"
import script from "./TraysMobile.vue?vue&type=script&lang=js&"
export * from "./TraysMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e66cb778')) {
      api.createRecord('e66cb778', component.options)
    } else {
      api.reload('e66cb778', component.options)
    }
    module.hot.accept("./TraysMobile.vue?vue&type=template&id=e66cb778&", function () {
      api.rerender('e66cb778', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/mobile/TraysMobile.vue"
export default component.exports